import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const awardInstitutionApi = generateNomenApi(`/nomen/award-institutions`);

export const awardInstitutionOptions = generateNomenOptions('award-institution', awardInstitutionApi);
